module.exports = __webpack_public_path__ + "img/img-17.c57a1c2c.webp";